import { makeAutoObservable } from "mobx"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import codeFormatTemplateService from "@services/codeFormatTemplate/codeFormatTemplateService"
import type {
  ICodeFormatTemplateCreateOrUpdateDto,
  ICodeFormatTemplateDto,
  ICodeFormatTemplatePreviewDto,
  ICodeFormatTemplatePreviewOutputDto,
  INumberingModuleDto,
  IPagedFilterCodeFormatTemplateDto,
} from "@services/codeFormatTemplate/codeFormatTemplateDto"

/** State màn "Mẫu mã tự sinh" (Feature-0371). */
class CodeFormatTemplateStore {
  tableData: PagedResultDto<ICodeFormatTemplateDto> = { items: [], totalCount: 0 }
  detailData: ICodeFormatTemplateDto | null = null
  listModule: INumberingModuleDto[] = []
  isLoading = false

  constructor() {
    makeAutoObservable(this)
  }

  async getAll(params: IPagedFilterCodeFormatTemplateDto) {
    this.isLoading = true
    try {
      this.tableData = await codeFormatTemplateService.getAll(params)
    } finally {
      this.isLoading = false
    }
  }

  async get(id: number) {
    this.isLoading = true
    try {
      this.detailData = await codeFormatTemplateService.get(id)
      return this.detailData
    } finally {
      this.isLoading = false
    }
  }

  async createOrUpdate(body: ICodeFormatTemplateCreateOrUpdateDto) {
    this.isLoading = true
    try {
      return await codeFormatTemplateService.createOrUpdate(body)
    } finally {
      this.isLoading = false
    }
  }

  async delete(id: number) {
    this.isLoading = true
    try {
      await codeFormatTemplateService.delete(id)
    } finally {
      this.isLoading = false
    }
  }

  /**
   * Nghiệp vụ cấu hình được mẫu. Chỉ nạp một lần cho cả tab lẫn modal — danh sách này tĩnh trong
   * một phiên làm việc, gọi lại mỗi lần mở modal chỉ tốn round-trip.
   */
  async getListModule() {
    if (this.listModule.length > 0) return this.listModule
    this.listModule = await codeFormatTemplateService.getListModule()
    return this.listModule
  }

  /**
   * Render thử mẫu. KHÔNG bật `isLoading` (dùng chung với nút Lưu — preview chạy debounce theo phím
   * gõ sẽ làm nút Lưu nhấp nháy) và KHÔNG giữ observable: kết quả chỉ sống trong modal đang mở.
   */
  async preview(
    body: ICodeFormatTemplatePreviewDto
  ): Promise<ICodeFormatTemplatePreviewOutputDto> {
    return codeFormatTemplateService.preview(body)
  }

  initDetail() {
    this.detailData = null
  }
}

export default CodeFormatTemplateStore
